module.exports = {
	"id": "CV",
	"name": "Cape Verde",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.00617,
			"12": 0.00617,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": 0.00617,
			"18": 0.00617,
			"19": 0.06787,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": 0.02468,
			"26": 0.01234,
			"27": 0.01234,
			"28": null,
			"29": 0.00617,
			"30": 0.01234,
			"31": 0.01234,
			"32": 0.01851,
			"33": 0.08638,
			"34": 0.02468,
			"35": 0.05553,
			"36": 0.12957,
			"37": 0.02468,
			"38": 0.00617,
			"39": 0.02468,
			"40": 0.12957,
			"41": null,
			"42": 0.08638,
			"43": 3.04181,
			"44": 0.19744,
			"45": 0.19744,
			"46": 0.03702,
			"47": 0.09255,
			"48": 0.04936,
			"49": 1.57952,
			"50": 0.12957,
			"51": 1.54867,
			"52": 0.617,
			"53": 26.24718,
			"54": 7.97781,
			"55": 0.17276,
			"56": 0.03085,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": 0.00617,
			"8": null,
			"9": null,
			"10": 0.00617,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.01851,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.01851,
			"28": null,
			"29": 0.01234,
			"30": null,
			"31": 0.00617,
			"32": 0.02468,
			"33": 0.00617,
			"34": 0.01234,
			"35": 0.01851,
			"36": null,
			"37": 0.01234,
			"38": 0.05553,
			"39": 0.02468,
			"40": 0.01234,
			"41": 0.03702,
			"42": 0.01851,
			"43": 0.09872,
			"44": 0.01851,
			"45": 0.05553,
			"46": 0.04319,
			"47": 0.63551,
			"48": 1.12294,
			"49": 2.81969,
			"50": 0.02468,
			"51": 0.04319,
			"52": null,
			"3.5": null,
			"3.6": 0.00617
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.00617,
			"29": 0.05553,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.00617,
			"34": 0.01851,
			"35": null,
			"36": 0.09872,
			"37": 0.03085,
			"38": 0.03702,
			"39": 0.07404,
			"40": 0.66636,
			"41": 0.06787,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.00617
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.00617,
			"6": null,
			"7": null,
			"8": 0.11723,
			"9": 0.11106,
			"10": 0.99337,
			"3.1": null,
			"3.2": null,
			"5.1": 0.03702,
			"6.1": 0.03702,
			"7.1": null,
			"9.1": 0.3085
		},
		"ios_saf": {
			"8": 0,
			"10": 2.09137684513,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0563601859908,
			"8.1-8.4": 0.104123055475,
			"9.0-9.2": 0.0496733842631,
			"9.3": 0.757837529142
		},
		"android": {
			"3": 0,
			"4": 0.146550770026,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0183188462532,
			"4.1": 0.528629563307,
			"4.2-4.3": 1.32157390827,
			"4.4": 3.03046056589,
			"4.4.3-4.4.4": 3.05663034625
		},
		"ie": {
			"6": 0.00629591836735,
			"7": null,
			"8": 0.232948979592,
			"9": 0.144806122449,
			"10": 0.409234693878,
			"11": 2.29171428571,
			"5.5": null
		},
		"op_mob": {
			"0": 0.203060577854,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00564057160705
		},
		"edge": {
			"12": 0.22212,
			"13": 0.49977,
			"14": 0.42573
		},
		"ie_mob": {
			"10": 0.328431126761,
			"11": 1.33718387324
		},
		"bb": {
			"7": 0.00670075,
			"10": null
		},
		"samsung": {
			"0": 1.156358
		},
		"and_uc": {
			"0": 1.236767
		},
		"op_mini": {
			"0": 2.73579985054
		},
		"and_chr": {
			"0": 25.340533
		},
		"and_ff": {
			"0": 0.068922
		}
	},
	"total": 98.32734175
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/CV.json
 ** module id = 502
 ** module chunks = 0
 **/